/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import ComboBox from "../../../components/ComboBox"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { showInfoToast } from "../../../components/CustomToast"
import { useDispatch } from "react-redux"
import { useHistory, useLocation, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setWarningAlerts } from "../../../globalStore/alertStore"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import CourseKyoriTarihuService from "../../../service/billing/courseKyoriTarihu/courseKyoriTarihuService"
import {
  TCourseKyoriTarihuGetListReq,
  TCourseKyoriTarihuList,
} from "../../../service/billing/courseKyoriTarihu/TCourseKyoriTarihu"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

import { 区分分類コード } from "../../../constant/enum/codes"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import TextInput from "../../../components/InputWrapper/TextInput"
import NinusiSearchModal from "../../../components/SearchModal/NinusiSearchModal"

import TumiOrosiSakiSearchModal from "../../../components/SearchModal/TumiOrosiSakiSearchModal"
import NinusiService from "../../../service/master/ninusi/ninusiService"
import KubunService from "../../../service/master/kubun/kubunService"

//#region dummy
export const 荷主ダミー = [
  { 荷主名: "アーステック株式会社", 荷主コード: "100001" },
  { 荷主名: "アサヒロジ株式会社", 荷主コード: "100002" },
]

//#endregion

/**
 * コース距離タリフ一覧
 * @returns
 */
const CourseKyoriTarihuRegister = () => {
  const history = useHistory()
  const location = useLocation()
  const { id: paramId } = useParams<{ id: string }>()
  const id = paramId ? parseInt(paramId) : undefined

  // ref
  const ref明細フォーマットフラグ = useRef<boolean>(false)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "CourseKyoriTarihuRegister_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TCourseKyoriTarihuList>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {},

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  // 検索前処理
  const beforeSearch = () => {
    // TODO:バリデーションチェック
    if (!isValidationCheckBeforeSearch()) return
    search()
  }

  /**
   * 検索時のチェック
   */
  const isValidationCheckBeforeSearch = () => {
    dispatch(clearAlert())
    Form外エラーメッセージList.splice(0, Form外エラーメッセージList.length)

    let hasError = false
    let messages: Array<string> = []

    // nullチェック
    // 荷主情報はモーダル画面で設定させるので、コードのみ判定
    if (荷主コード == null) {
      messages.push(`荷主情報 を入力してください。`)
      hasError = true
    }

    // error判定とメッセージセット
    if (hasError) {
      Form外エラーメッセージList.push(...messages)
      setHasSearched(hasError)
    }
    return !hasError
  }

  /**
   * IDがある場合の荷主検索
   */
  const loadNinusiSearch = async () => {
    try {
      const res = await new NinusiService().getList({
        荷主ID: id,
      })
      set荷主ID(res.data[0].荷主ID)
      set荷主コード(res.data[0].荷主コード)
      set荷主名(res.data[0].荷主名)
    } catch (error) {
      throw error
    }
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TCourseKyoriTarihuGetListReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に
    setIsSubmitButton(false)

    let currentSearchCondition: TCourseKyoriTarihuGetListReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new CourseKyoriTarihuService().getList(
        currentSearchCondition
      )
      // formatItemを入れなおすためフラグを切り替え
      ref明細フォーマットフラグ.current = false

      // 検索結果をstateにセット
      set荷主ID(res.data.荷主ID)
      set更新日時(res.data.更新日時)
      setModifyToken(res.data.modifyToken)

      // 正常に検索した場合に検索完了フラグ制御
      flexGrid!.isReadOnly = false
      // uniqueな荷主の明細を取得
      setGridData({
        data: createCollectionView(res.data.コース距離タリフ明細, pageSize),
      })
      setAccordionController(false)
    } catch (error) {
      // dispatch(setAlerts(error))
      dispatch(setWarningAlerts(["エラー表示"]))
      if (flexGrid) {
        flexGrid.isReadOnly = true
      }
    } finally {
      setIsSearching(false) // 検索中状態に遷移
      setIsSubmitButton(true)
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TCourseKyoriTarihuGetListReq = queryString.parse(
      location.search
    )
    set荷主ID(query.荷主ID)
    set荷主コード(query.荷主コード)
    set荷主名(query.荷主名)
    set積地社名(query.積地_社名)
    set積地県名(query.積地_都道府県)
    set積地市区町村(query.積地_市区町村)
    set卸地社名(query.卸地_社名)
    set卸地県名(query.卸地_都道府県)
    set卸地市区町村(query.卸地_市区町村)
    set単価設定区分コード(query.運賃単価設定区分)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TCourseKyoriTarihuGetListReq => {
    return {
      荷主ID,
      荷主コード,
      荷主名,
      運賃単価設定区分: 単価設定区分コード ?? "",
      積地_社名: 積地社名,
      積地_都道府県: 積地県名,
      積地_市区町村: 積地市区町村,
      卸地_社名: 卸地社名,
      卸地_都道府県: 卸地県名,
      卸地_市区町村: 卸地市区町村,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TCourseKyoriTarihuGetListReq
  ) => {
    const d単価設定区分 = 単価設定区分ItemSource
      ?.filter((d) => d.分類コード === "T0023")
      .find((i) => i.区分コード === searchCondition.運賃単価設定区分)

    return {
      荷主コード: wjCore.isNullOrWhiteSpace(searchCondition.荷主コード ?? "")
        ? ""
        : searchCondition.荷主コード,
      荷主名: wjCore.isNullOrWhiteSpace(searchCondition.荷主名 ?? "")
        ? ""
        : searchCondition.荷主名,
      単価設定区分: d単価設定区分
        ? `${d単価設定区分.区分コード} ${d単価設定区分.名称1}`
        : undefined,
      積地社名: searchCondition.積地_社名,
      積地県名: searchCondition.積地_都道府県,
      積地市区町村: searchCondition.積地_市区町村,
      卸地社名: searchCondition.卸地_社名,
      卸地県名: searchCondition.卸地_都道府県,
      卸地市区町村: searchCondition.卸地_市区町村,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    dispatch(clearAlert())
  }

  const clearSearchState = () => {
    if (!id) {
      set荷主コード("")
      set荷主名("")
    }

    set積地社名("")
    set積地県名("")
    set積地市区町村("")
    set卸地社名("")
    set卸地県名("")
    set卸地市区町村("")
    set単価設定区分コード("")
    set単価設定区分(undefined)
    setIsSubmitButton(false)

    ref明細フォーマットフラグ.current = false
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    // 追加行のみ初期化時に設定
    var extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      // 固定部分
      if (c.binding?.includes("積地_")) {
        columnHeaders.setCellData(0, index, "積地")
      } else if (c.binding?.includes("卸地_")) {
        columnHeaders.setCellData(0, index, "卸地")
      } else {
        const setHeaderText = c.header ?? ""
        columnHeaders.setCellData(0, index, setHeaderText)
      }
      c.allowMerging = true
    })

    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    // ループをフラグで制御？
    if (ref明細フォーマットフラグ.current) return

    //TODO: データ行の有無に加えて、荷主検索出来ている事も条件にする
    // AddNew行を除いてデータ行がある場合に登録ボタン制御
    if (f.rows.length > 1) {
      setIsSubmitButton(true)
    } else {
      setIsSubmitButton(false)
    }

    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (e.getRow().dataItem.削除フラグ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
      }
    }
    // フォーマットのループ制御
    // ref明細フォーマットフラグ.current = true
  }

  const beforeSubmit = () => {
    // TODO:バリデーションチェック

    setIsConfirmModalShow(true)
  }

  // TODO:PUTのみ？
  const submit = async () => {
    showInfoToast(`submitてすと`)
    setIsConfirmModalShow(false)
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // gridのリスト用DataMap
  const [運賃単価設定区分DataMap, set運賃単価設定区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [車種区分DataMap, set車種区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [銅種区分DataMap, set銅種区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  // 荷主検索用
  const [選択行, set選択行] = useState<wjcGrid.Row>()
  const [is荷主検索Modal, setIs荷主検索Modal] = useState(false)
  // 積卸先検索
  const [is積卸先検索Modal, setIs積卸先検索Modal] = useState(false)
  const [積卸先検索対象, set積卸先検索対象] = useState<"積" | "卸">("積")

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中
  const [isSubmitButton, setIsSubmitButton] = useState(false) // 検索後

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // errorフラグ
  const [hasSearched, setHasSearched] = useState(false)
  const [Form外エラーメッセージList] = useState<string[]>([])

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [荷主ID, set荷主ID] = useState<number>()
  const [
    ,
    // 更新日時
    set更新日時,
  ] = useState<string>()
  const [
    ,
    // modifyToken
    setModifyToken,
  ] = useState<string>()

  // state
  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主名, set荷主名] = useState<string>()

  // 積地
  const [積地社名, set積地社名] = useState<string>()
  const [積地県名, set積地県名] = useState<string>()
  const [積地市区町村, set積地市区町村] = useState<string>()
  // 卸地
  const [卸地社名, set卸地社名] = useState<string>()
  const [卸地県名, set卸地県名] = useState<string>()
  const [卸地市区町村, set卸地市区町村] = useState<string>()

  // ComboBox
  // 単価設定区分
  const [単価設定区分コード, set単価設定区分コード] = useState<string | null>()
  const [, set単価設定区分] = useState<T区分マスタ | null>()
  const [単価設定区分ItemSource, set単価設定区分ItemSource] =
    useState<T区分マスタ[]>()
  const [単価設定区分ComboBox, set単価設定区分ComboBox] =
    useState<TWijmoComboBox<T区分マスタ["区分コード"], T区分マスタ> | null>(
      null
    )
  const [単価設定区分IsLoadEnded, set単価設定区分IsLoadEnded] =
    useState<boolean>(false)

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `コース距離運賃タリフ登録`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])

  //DataMap設定
  useEffect(() => {
    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      set単価設定区分ItemSource(区分マスタRes.data)
      set運賃単価設定区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) =>
              d.分類コード === 区分分類コード.受注配車_請求支払.運賃単価設定区分
          ),
          "区分コード",
          "名称1"
        )
      )
      set車種区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.車輌.車種区分
          ),
          "区分コード",
          "名称1"
        )
      )

      set銅種区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.マスタ.品名種別区分
          ),
          "区分コード",
          "名称1"
        )
      )
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
        // 編集で遷移してきた場合、荷主を検索
      } else if (id) {
        loadNinusiSearch().finally(() => {
          dispatch(画面ロック解除())
        })
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  // error監視
  useEffect(() => {
    if (hasSearched && [...Form外エラーメッセージList].find((e) => e !== "")) {
      dispatch(setWarningAlerts([...Form外エラーメッセージList]))
    }
    setHasSearched(false)
  }, [hasSearched])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">コース距離運賃タリフ登録</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-80rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    {/* 固定項目 */}
                    <Row>
                      <Col>
                        <ul className="list-cmn">
                          <li className="list-cmn d-flex">
                            <div className="d-flex">
                              <TextInput
                                style={{ width: "7rem" }}
                                id="荷主コード"
                                name="荷主コード"
                                value={荷主コード}
                                setValue={() => {}}
                                isReadOnly
                                isRequired
                                maxLength={6}
                                placeholder="荷主コード"
                              />
                              {!id && (
                                <button
                                  type="button"
                                  className="icon-button"
                                  style={{
                                    minWidth: "1rem",
                                  }}
                                  onClick={() => {
                                    setIs荷主検索Modal(true)
                                  }}>
                                  <FontAwesomeIcon
                                    className="icon-button-inner"
                                    icon={faSearch}
                                  />
                                </button>
                              )}
                              <TextInput
                                style={{ width: "25rem" }}
                                id="荷主名"
                                name="荷主名"
                                value={荷主名}
                                setValue={() => {}}
                                isReadOnly
                                isRequired
                                maxLength={100}
                                placeholder="荷主名"
                              />
                              <span className="list-padding"></span>
                              <ComboBox.Kubun
                                placeholder="単価設定区分"
                                isAllSelect={true}
                                分類コード="T0023"
                                itemsSource={単価設定区分ItemSource}
                                isLoadEnded={単価設定区分IsLoadEnded}
                                setIsLoadEnded={set単価設定区分IsLoadEnded}
                                setSelectedValue={set単価設定区分コード}
                                selectedValue={単価設定区分コード}
                                setSelectedItem={set単価設定区分}
                                ComboBox={単価設定区分ComboBox}
                                setComboBox={
                                  set単価設定区分ComboBox
                                }></ComboBox.Kubun>
                            </div>
                          </li>
                          <li className="list-cmn d-flex">
                            <div className="d-flex">
                              <TextInput
                                style={{ width: "12rem" }}
                                id="積地社名"
                                name="積地社名"
                                value={積地社名}
                                setValue={(v) => {
                                  set積地社名(v)
                                }}
                                placeholder="積地社名"
                              />
                              <TextInput
                                style={{ width: "8rem" }}
                                id="積地県名"
                                name="積地県名"
                                value={積地県名}
                                setValue={(v) => {
                                  set積地県名(v)
                                }}
                                placeholder="積地県名"
                              />
                              <TextInput
                                style={{ width: "15rem" }}
                                id="積地市区町村"
                                name="積地市区町村"
                                value={積地市区町村}
                                setValue={(v) => {
                                  set積地市区町村(v)
                                }}
                                placeholder="積地市区町村"
                              />
                            </div>
                            <div className="list-padding d-flex">
                              <TextInput
                                style={{ width: "12rem" }}
                                id="卸地社名"
                                name="卸地社名"
                                value={卸地社名}
                                setValue={(v) => {
                                  set卸地社名(v)
                                }}
                                placeholder="卸地社名"
                              />
                              <TextInput
                                style={{ width: "8rem" }}
                                id="卸地県名"
                                name="卸地県名"
                                value={卸地県名}
                                setValue={(v) => {
                                  set卸地県名(v)
                                }}
                                placeholder="卸地県名"
                              />
                              <TextInput
                                style={{ width: "15rem" }}
                                id="卸地市区町村"
                                name="卸地市区町村"
                                value={卸地市区町村}
                                setValue={(v) => {
                                  set卸地市区町村(v)
                                }}
                                placeholder="卸地市区町村"
                              />
                            </div>
                          </li>
                        </ul>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            beforeSearch()
                          }}>
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>

              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={
                  CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                }
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                isShowGridRowPickupButton={false}
                gridProperties={{
                  newRowAtTop: true,
                  isReadOnly: true,
                  allowMerging: "ColumnHeaders",
                  allowDragging: wjcGrid.AllowDragging.None,
                }}
                headerComponent={
                  <>
                    <div>
                      <Button
                        type="button"
                        variant={isSubmitButton ? "primary" : "secondary"}
                        className="ms-4"
                        disabled={!isSubmitButton}
                        onClick={() => {
                          // TODO:登録,Validation,
                          beforeSubmit()
                        }}>
                        登録
                      </Button>
                    </div>
                  </>
                }>
                <wjrGrid.FlexGridColumn
                  binding="積地_コード"
                  width={170}
                  header="コード">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TCourseKyoriTarihuList>
                    ) => {
                      return (
                        <div className="d-flex justify-content-between">
                          <div className="text-start">
                            {context.item.積地_コード}
                          </div>
                          <div className="text-end">
                            <a
                              href="*"
                              onClick={(e) => {
                                e.preventDefault()
                                set選択行(context.row)
                                set積卸先検索対象("積")
                                setIs積卸先検索Modal(true)
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                            </a>
                          </div>
                        </div>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="積地_社名"
                  width={170}
                  header="社名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="積地_都道府県名称"
                  width={90}
                  header="県"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="積地_市区町村"
                  width={160}
                  header="市区町村"></wjrGrid.FlexGridColumn>

                <wjrGrid.FlexGridColumn
                  binding="卸地_コード"
                  width={170}
                  header="コード">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TCourseKyoriTarihuList>
                    ) => {
                      return (
                        <div className="d-flex justify-content-between">
                          <div className="text-start">
                            {context.item.卸地_コード}
                          </div>
                          <div className="text-end">
                            <a
                              href="*"
                              onClick={(e) => {
                                e.preventDefault()
                                set選択行(context.row)
                                set積卸先検索対象("卸")
                                setIs積卸先検索Modal(true)
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                            </a>
                          </div>
                        </div>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="卸地_社名"
                  width={170}
                  header="社名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="卸地_都道府県名称"
                  width={90}
                  header="県"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="卸地_市区町村"
                  width={160}
                  header="市区町村"></wjrGrid.FlexGridColumn>

                <wjrGrid.FlexGridColumn
                  binding="運賃単価設定区分"
                  width={170}
                  dataMap={運賃単価設定区分DataMap}
                  header="運賃単価設定区分"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="車種区分"
                  width={170}
                  dataMap={車種区分DataMap}
                  header="車種区分"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="銅種コード"
                  width={170}
                  dataMap={銅種区分DataMap}
                  header="銅種"></wjrGrid.FlexGridColumn>

                <wjrGrid.FlexGridColumn
                  binding="備考"
                  width={260}
                  header="備考"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* 荷主検索 */}
      <NinusiSearchModal
        size="lg"
        setIsShow={setIs荷主検索Modal}
        isShow={is荷主検索Modal}
        setNinusi={(荷主請求) => {
          set荷主コード(荷主請求.荷主コード)
          set荷主名(荷主請求.荷主名)
        }}></NinusiSearchModal>
      {/* 積卸先検索 */}
      <TumiOrosiSakiSearchModal
        size="lg"
        setIsShow={setIs積卸先検索Modal}
        isShow={is積卸先検索Modal}
        setTumiOrosiSaki={(積卸先) => {
          if (選択行 && 選択行.dataItem) {
            const casted: TCourseKyoriTarihuList = 選択行.dataItem
            switch (積卸先検索対象) {
              case "積":
                casted.積地_id = 積卸先.積卸先ID
                casted.積地_コード = 積卸先.積卸先コード
                casted.積地_社名 = 積卸先.積卸先名
                casted.積地_都道府県コード = 積卸先.都道府県コード ?? ""
                casted.積地_都道府県名称 = 積卸先.都道府県名漢字 ?? ""
                casted.積地_市区町村 = 積卸先.住所２ ?? ""

                break
              case "卸":
                casted.卸地_id = 積卸先.積卸先ID
                casted.卸地_コード = 積卸先.積卸先コード
                casted.卸地_社名 = 積卸先.積卸先名
                casted.卸地_都道府県コード = 積卸先.都道府県コード ?? ""
                casted.卸地_都道府県名称 = 積卸先.都道府県名漢字 ?? ""
                casted.卸地_市区町村 = 積卸先.住所２ ?? ""

                break
              default:
                break
            }
            flexGrid?.refresh()
          }
        }}></TumiOrosiSakiSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </Container>
  )
}

export default CourseKyoriTarihuRegister
